import moment from 'moment';
import { Keys, locale } from 'src/i18n';
import { USER_OPTION_COLOR } from './constants';
import {
  CreateNotePayload,
  CreateNotePayloadParams,
  EditorOptionsSelected,
  NotesUser,
  UserOption,
} from './types';

export const getUserOptions = (users: NotesUser[] = []): UserOption[] =>
  users.map((user) => ({
    label: user.displayName,
    name: user.name,
    code: user.code,
    value: user.code,
    color: USER_OPTION_COLOR,
    editorProps: { type: 'triggerFields' },
  }));

export const getMentions = (optionsSelected: EditorOptionsSelected = {}) =>
  (optionsSelected.triggerFields || []).map(({ code = '', name = '' }) => ({
    code,
    name,
  }));

export const getCreateNotePayload = ({
  html,
  mention,
  userCode,
  isPrivate,
  voId,
  parentKey,
}: CreateNotePayloadParams): CreateNotePayload => ({
  inputs: {
    note: html,
    mention,
  },
  added_by: userCode,
  visibility: isPrivate ? 'private' : 'public',
  vo_id: voId,
  ...(parentKey ? { parent_key: parentKey } : {}),
});

export const getNoteAuthorInitial = (name?: string) => name?.charAt(0) || '?';

export const getFormattedNoteDate = (createdDate: string) =>
  moment(createdDate).format('D MMMM YYYY [at] h:mm A');

export const getReplyButtonLabel = (
  childCount: number,
  showReplyView: boolean,
) => {
  if (showReplyView) {
    return locale(Keys.HIDE_REPLIES);
  }

  return `${childCount} ${
    childCount > 1 ? locale(Keys.REPLIES) : locale(Keys.REPLY)
  }`;
};

export const trimHtml = (html: string): boolean =>
  html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;|&#x[aA]0;|[\u00a0\u200b]/gi, '')
    .trim().length === 0;
